import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { EventCardHome } from 'shared/components/eventCardHome';
import { APP_URL } from 'shared/constants/common';
import HotBanner from 'shared/HotBanner/HotBanner';
import { SportsType } from 'shared/interface';
import { HotBannerData } from 'shared/types/cms';
import TabAnimationWrapper from '../../../shared/components/tabAnimationWrapper/tabAnimationWrapper';
import { getParticipants } from '../../../shared/util/utility';
import { EsSportEventData } from '../../esSport/interface/interface';
import { MobileHomepage } from '../../installPwa';
import './styles.scss';

type LiveEventPopularProps = {
	popularLiveBettingData: EsSportEventData[];
	hotBannerData: HotBannerData[];
	isLiveHotBanners: boolean;
	isHotTabSelected: boolean;
	liveTab: SportsType | undefined;
};

const LiveEventsPopular = ({ liveTab, popularLiveBettingData, hotBannerData, isLiveHotBanners, isHotTabSelected }: LiveEventPopularProps) => {
	const { t } = useTranslation();

	return (
		<>
			<TabAnimationWrapper>
				{popularLiveBettingData?.map((item, key: number) => {
					return (
						<Fragment key={key}>
							<EventCardHome
								key={`sportsData-events-${item.eventId}`}
								categoryId={item.categoryId}
								eventStart={item.eventStart}
								gamesCount={item.gamesCount}
								infos={item.infos}
								participants={getParticipants(item)}
								sportID={item.sportId}
								parentId={item.parentId}
								event={{ ...(item.games?.length > 0 ? item.games[0] : {}), ...item }}
								isLive
								partialScores={!!item.partialScores ? item.partialScores.split('-') : []}
								isTwitch={!!item.extras && item.extras.twitchChannel}
								isStatScore={item.extras && item.extras.liveScoreProEventId}
							/>
							{key === 0 && <MobileHomepage forceUpdate={popularLiveBettingData} />}
						</Fragment>
					);
				})}

				{isHotTabSelected && <HotBanner hotBannerData={hotBannerData} isLiveBanners={isLiveHotBanners} />}
			</TabAnimationWrapper>

			{liveTab && (
				<NavLink to={`${APP_URL.live}?id=${liveTab?.sportId}`} className="liveEventsPopular__button">
					{t('checkAllLiveMatches')}
				</NavLink>
			)}
		</>
	);
};

export default LiveEventsPopular;
